import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('rates'),
    component: () => import('@/views/RatesList.vue'),
    props: true,
  },
  {
    ...screen('rates-edit'),
    component: () => import('@/views/RatesEdit.vue'),
    props: true,
  },

  // redirects
  // ...
];
